import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Mobile",
    component: () => import("@/views/MobileView.vue"),
    meta: {
      title: "河南社保表单验证",
      showCommon: false,
    },
  },{
    path: '/pc',
    name: 'pc',
    component: () => import('@/views/PcView.vue'),
    meta: {
      title:'河南社保表单验证',
      showCommon: true
    }
  }
];

// 3. 创建路由实例并传递 `routes` 配置。

const router = createRouter({
  // 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: createWebHashHistory(),
  routes, // `routes: routes` 的缩写
});

router.beforeEach((to,from)=>{
    console.log(to,from);
})
 

export default router;
